"use client";

import { AssessmentRhythmBanner } from "@/components/assessment/AssessmentRhythmBanner";
import type { AssessmentEntryKey } from "@/hooks/use-assessment-rhythm-bridge";
import { useAssessmentRhythmBridge } from "@/hooks/use-assessment-rhythm-bridge";

interface AssessmentBannerSlotProps {
  userId?: string | null;
  locale: string;
  entry: AssessmentEntryKey;
  conversationCount?: number;
  className?: string;
}

export function AssessmentBannerSlot({
  userId,
  locale,
  entry,
  conversationCount,
  className,
}: AssessmentBannerSlotProps) {
  const isAuthenticated = Boolean(userId);
  const { bannerState, acknowledge, remindLater, dismissForDay } =
    useAssessmentRhythmBridge({
      userId,
      locale,
      entry,
      enabled: isAuthenticated,
      conversationCount,
    });

  if (!isAuthenticated || !bannerState.visible) {
    return null;
  }

  return (
    <div className={className}>
      <AssessmentRhythmBanner
        state={bannerState}
        onAction={acknowledge}
        onRemindLater={() => {
          acknowledge();
          remindLater();
        }}
        onDismiss={() => {
          acknowledge();
          dismissForDay();
        }}
      />
    </div>
  );
}
